export function toQueryString(obj) {
  let str = []
  for (let p in obj) {
    if (obj[p] !== undefined && obj[p] !== null) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  }

  return str.join('&')
}
